import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'INVIT_FOURN',
  title: 'Comment inviter mes fournisseurs ?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Inviter vos fournisseurs / sous-traitants vous permettra d’avoir accès à leurs documents sur la plateforme à chaque fois que vous en avez besoin.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Rendez-vous sur l’onglet « Fournisseurs »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INVIT_FOURN/FR_INVIT_FOURN_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Cliquez sur le bouton « Rechercher un fournisseur » situé en haut à droite'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INVIT_FOURN/FR_INVIT_FOURN_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'S’il apparait dans la liste, un simple clic dessus l’ajoute à votre liste de fournisseurs.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INVIT_FOURN/FR_INVIT_FOURN_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Si vous ne trouvez pas votre fournisseur, il se peut qu’il ne soit pas adhérent à la plateforme. Procédez donc à une invitation en remplissant le formulaire d’invitation, puis validez.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INVIT_FOURN/FR_INVIT_FOURN_4.png`
  }]
};
